export default "__VITE_ASSET__b350acbc__"